// @flow

import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';
import { type UserInputValues } from '@tectonics/prs/user-input-values';

export async function safetypayOutgoingPaymentMapper(userInputValues: UserInputValues): Promise<$Shape<OutgoingPayment>> {
  const selectedSafetyPayOption = userInputValues['selectedSafetypayOption'];
  return {
    payment_type: 'safetypay',
    payment_type_code: selectedSafetyPayOption,
  };
}
